export const GET_ALL_BRAND_REQUEST = "GET_ALL_BRAND_REQUEST";
export const GET_ALL_BRAND_FAILURE = "GET_ALL_BRAND_FAILURE";
export const GET_ALL_BRAND_SUCCESS = "GET_ALL_BRAND_SUCCESS";

export const CREATE_BRAND_REQUEST = "CREATE_BRAND_REQUEST";
export const CREATE_BRAND_FAILURE = "CREATE_BRAND_FAILURE";
export const CREATE_BRAND_SUCCESS = "CREATE_BRAND_SUCCESS";

export const UPDATE_BRAND_REQUEST = "UPDATE_BRAND_REQUEST";
export const UPDATE_BRAND_FAILURE = "UPDATE_BRAND_FAILURE";
export const UPDATE_BRAND_SUCCESS = "UPDATE_BRAND_SUCCESS";

export const DELETE_BRAND_REQUEST = "DELETE_BRAND_REQUEST";
export const DELETE_BRAND_FAILURE = "DELETE_BRAND_FAILURE";
export const DELETE_BRAND_SUCCESS = "DELETE_BRAND_SUCCESS";